module.exports = __webpack_public_path__ + "img/bell-lighter.925cee76.svg";